<section class="position-relative">
  <div class="nav-plus-pos-dashboard position-relative">
    <nav class="position-sticky w-100">
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex">
          <div>
            <img src="assets/images/onboarding/ic_brijj.svg" alt="" class="" />
          </div>
          <div class="menu-list">
            <ul class="mb-0">
              <li routerLink="/home">Home</li>
              <li>Products</li>
              <li>Pricing</li>
            </ul>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <div>
            <button class="btn sign-btn">Sign in</button>
            <button
              class="btn sign-btn ms-2"
              style="color: #fff; background: rgba(33, 150, 243, 1)"
            >
              Sign up
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div class="pos-dashboard">
      <div class="d-flex justify-content-between h-100">
        <div style="flex-basis: 50%" class="title-section">
          <div class="">
            <h1 class="section-title">Landing Page Title</h1>
            <p class="page-text">
              Lorem ipsum dolor sit amet consectetur. Iaculis sem accumsan donec sagittis proin
              blandit et purus nunc. Sit enim adipiscing parturient ut est eget accumsan amet nisi.
              Lectus augue non mauris duis amet. Aliquam aliquam arcu tristique suspendisse lacus
              odio faucibus pulvinar.
            </p>
          </div>
        </div>

        <div style="flex-basis: 50%" class="pos-dashboard-img">
          <img src="assets/images/landing-page/pos_Dashboard.png" alt="" class="w-100 h-100" />
        </div>
      </div>
    </div>
    <!-- <div class="drop-shadow-container position-absolute">
       <div class="d-flex h-100">
        <div style="flex-basis: 50%;"></div>
        <div style="flex-basis: 50%;" class="drop-shadow"></div>
       </div>

    </div> -->
  </div>

  <div class="platforms-list menu-list">
    <ul class="d-flex justify-content-evenly ps-0">
      <li *ngFor="let item of platformList" class="d-flex">
        <div><img [src]="item.img" alt="" /></div>
        <div style="font-weight: 800; font-size: 32px" class="ps-3">
          {{ item.title }}
        </div>
      </li>
    </ul>
  </div>

  <div class="self-checkout-section">
    <div></div>
    <div class="d-flex justify-content-between flex-column" style="height: 9rem">
      <div class="sub-header mx-auto">
        <p class="mb-0">sub-header</p>
      </div>
      <div class="text-center">
        <h1 style="font-size: 36px; font-weight: 800">Title text</h1>
        <p class="page-text">Lorem ipsum dolor sit amet consectetur.</p>
      </div>
    </div>

    <div class="self-checkout-container">
      <div class="d-flex">
        <div style="flex-basis: 50%">
          <img src="assets/images/landing-page/selfCheckout.png" alt="" class="w-100 h-100" />
        </div>
        <div
          style="flex-basis: 50%; margin-inline-start: 4rem"
          class="d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-between flex-column">
            <div>
              <img src="assets/images/landing-page/ic_checkout.svg" alt="" />
            </div>
            <div class="mt-4">
              <h1 class="heading-30px">Tincidunt arcu non sodales neque sodales ut etiam sit.</h1>
              <p class="page-text" style="font-size: 18px" class="mt-3">
                Ac turpis egestas maecenas pharetra convallis. Pharetra diam sit amet nisl. Justo
                donec enim diam vulputate ut pharetra sit amet aliquam.
              </p>
            </div>
            <div>
              <ul class="selfCheckout-benefits ps-0 mt-4">
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="profile-section">
    <div></div>

    <div class="self-checkout-container">
      <div class="d-flex">
        <div
          style="flex-basis: 50%; margin-inline-end: 4rem"
          class="d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-between flex-column">
            <div>
              <img src="assets/images/landing-page/ic_image.svg" alt="" />
            </div>
            <div class="mt-4">
              <h1 class="heading-30px">Vulputate dignissim suspendisse in est ante in nibh.</h1>
              <p class="page-text" style="font-size: 18px" class="mt-3">
                Ac turpis egestas maecenas pharetra convallis. Pharetra diam sit amet nisl. Justo
                donec enim diam vulputate ut pharetra sit amet aliquam.
              </p>
            </div>
            <div>
              <ul class="selfCheckout-benefits ps-0 mt-4">
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="flex-basis: 50%">
          <img src="assets/images/landing-page/profile.png" alt="" class="w-100 h-100" />
        </div>
      </div>
    </div>
  </div>

  <div class="profile-section">
    <div></div>

    <div class="self-checkout-container">
      <div class="d-flex">
        <div style="flex-basis: 50%">
          <img src="assets/images/landing-page/categories.png" alt="" class="w-100 h-100" />
        </div>
        <div
          style="flex-basis: 50%; margin-inline-start: 4rem"
          class="d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-between flex-column">
            <div>
              <img src="assets/images/landing-page/ic_favourite.svg" alt="" />
            </div>
            <div class="mt-4">
              <h1 class="heading-30px">Aliquet sagittis id consectetur purus ut faucibus.</h1>
              <p class="page-text" style="font-size: 18px" class="mt-3">
                n metus vulputate eu scelerisque felis imperdiet proin fermentum leo. Diam quis enim
                lobortis scelerisque fermentum dui faucibus.
              </p>
            </div>
            <div>
              <ul class="selfCheckout-benefits ps-0 mt-4">
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
                <li class="d-flex">
                  <img src="assets/images/landing-page/ic_checked.svg" alt="" />
                  <p class="ms-2">App feature text</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="testomonial">
    <div class="text-center d-flex justify-content-evenly flex-column h-100">
      <div class="platform-logo mx-auto">
        <img src="assets/images/onboarding/ic_pos.svg" alt="" />
      </div>
      <h1 style="font-size: 36px">
        Lorem ipsum dolor sit amet consectetur. Quisque mi hendrerit et varius id amet dolor. Neque
        feugiat ac elementum purus vitae.
      </h1>
      <div class="users-profile">
        <img src="assets/images/landing-page/ic_avatar.png" alt="" />
        <p class="page-text" style="font-weight: 800; color: #1e293b">Dwayne Reynolds</p>
        <p style="font-size: #475569">CEO, Paris Texas Apparel Co</p>
      </div>
    </div>
  </div>

  <div class="site-figures">
    <div class="d-flex justify-content-center flex-column h-100 text-center">
      <div>
        <img src="assets/images/landing-page/ic_checkout.svg" alt="" />
      </div>
      <div class="mt-4">
        <h1 class="heading-30px">Title Text</h1>
      </div>
      <div>
        <p class="page-text mt-3">
          Liquam id diam maecenas ultricies mi eget mauris pharetra et. Feugiat pretium nibh ipsum
          consequat nisl vel pretium lectus. Fermentum iaculis eu non diam.
        </p>
      </div>
      <ul class="figures d-flex mx-auto mt-5">
        <li>
          <div>
            <h1>420%</h1>
            <p>Text</p>
          </div>
        </li>
        <li>
          <div>
            <h1>708+</h1>
            <p>Text</p>
          </div>
        </li>
        <li style="border: none">
          <div>
            <h1>1.82M</h1>
            <p>Text</p>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="get-started">
    <div class="text-center">
      <div class="">
        <h1 class="heading-30px">Title Text</h1>
      </div>
      <div>
        <p class="page-text mt-3">
          Liquam id diam maecenas ultricies mi eget mauris pharetra et. Feugiat pretium nibh ipsum
          consequat nisl vel pretium lectus. Fermentum iaculis eu non diam.
        </p>
      </div>
      <div class="mt-4">
        <button class="btn start-btn" style="color: #0070b9">Sign in</button>
        <button class="btn start-btn ms-2" style="color: #fff; background: rgba(33, 150, 243, 1)">
          Sign up
        </button>
      </div>
    </div>
  </div>

  <footer>
    <div class="text-center">
      <img src="assets/images/landing-page/ic_rcs.svg" alt="" />

      <ul class="footer-menu d-flex justify-content-center mt-3 ps-0">
        <li>Homepage</li>
        <li>Products</li>
        <li>About Us</li>
        <li>Contact Us</li>
      </ul>

      <ul class="footer-menu d-flex justify-content-center mt-4 ps-0">
        <li><img src="assets/images/landing-page/ic_fb.svg" alt="" /></li>
        <li><img src="assets/images/landing-page/ic_x.svg" alt="" /></li>
        <li><img src="assets/images/landing-page/ic_insta.svg" alt="" /></li>
        <li><img src="assets/images/landing-page/ic_linkdin.svg" alt="" /></li>
      </ul>
    </div>
  </footer>
</section>
